import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { updateBidderForEvent, getAuctionEventByUuid } from "services";
import {
  BetaForm as useBetaForm,
  ButtonBase,
  TextInputBase,
} from "@reusejs/react";
import Loader from "../../../layouts/Loader";
import { useRouter } from "next/router";
import axios from "axios";

const BidForm = ({ bidderData, id, currentStep, nextStep }: any) => {
  const router = useRouter();
  const onboarding: any = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });

  const ifscRegEx: RegExp = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const bidForm = useBetaForm({
    email: onboarding.email || "",
    mobile: onboarding.mobile || "",
    name: onboarding.name || "",
    authorized_person_name: onboarding.authorized_person_name || "",
    father_spouse_name: "",
    full_address: onboarding.full_address || "",
    bid_amount: "",
    emd_amount: "",
    // aadhaar:
    //   bidderData?.kyc_data?.other_document_data?.document_type === "aadhaar"
    //     ? bidderData?.kyc_data?.other_document_data?.document_value
    //     : onboarding.adhaar
    //     ? onboarding.adhaar
    //     : "" || "",
    pan: bidderData?.kyc_data?.pan_data?.document_value
      ? bidderData?.kyc_data?.pan_data?.document_value
      : onboarding.pan
      ? onboarding.pan
      : "" || "",
    account_name: "",
    account_number: "",
    account_type: "",
    bank_name: "",
    ifsc_code: "",
  });

  const form_constraints = {
    father_spouse_name: {
      presence: {
        allowEmpty: onboarding.authorized_person_name ? true : false,
      },
    },
    full_address: {
      presence: {
        allowEmpty: false,
      },
    },
    bid_amount: {
      presence: {
        allowEmpty: false,
      },
    },
    emd_amount: {
      presence: {
        allowEmpty: false,
      },
    },
    account_name: {
      presence: {
        allowEmpty: false,
      },
    },
    account_number: {
      presence: {
        allowEmpty: false,
      },
    },
    account_type: {
      presence: {
        allowEmpty: false,
      },
    },
    bank_name: {
      presence: {
        allowEmpty: false,
      },
    },
    ifsc_code: {
      presence: {
        allowEmpty: false,
      },
      length: {
        maximum: 11,
      },
      format: {
        pattern: ifscRegEx,
      },
    },
  };
  useEffect(() => {
    bidForm.setValidationRules(form_constraints);
    getEventData();
  }, []);

  useEffect(() => {
    if (bidderData && bidderData?.application_form_data) {
      preFillData(bidderData?.application_form_data);
    }
  }, [bidderData]);

  const preFillData = (data: any) => {
    if (data) {
      bidForm.setField("email", data?.email ? data?.email : "");
      bidForm.setField("mobile", data?.mobile ? data?.mobile : "");
      bidForm.setField("name", data?.name ? data?.name : "");
      bidForm.setField(
        "authorized_person_name",
        data?.authorized_person_name ? data?.authorized_person_name : ""
      );
      bidForm.setField(
        "father_spouse_name",
        data?.father_spouse_name ? data?.father_spouse_name : ""
      );
      bidForm.setField("pan", data?.pan ? data?.pan : "");
      bidForm.setField(
        "full_address",
        data?.full_address ? data?.full_address : ""
      );
      bidForm.setField("bid_amount", data?.bid_amount ? data?.bid_amount : "");
      bidForm.setField("emd_amount", data?.emd_amount ? data?.emd_amount : "");
      bidForm.setField(
        "account_name",
        data?.account_name ? data?.account_name : ""
      );
      bidForm.setField(
        "account_number",
        data?.account_number ? data?.account_number : ""
      );
      bidForm.setField(
        "account_type",
        data?.account_type ? data?.account_type : ""
      );
      bidForm.setField("bank_name", data?.bank_name ? data?.bank_name : "");
      bidForm.setField("ifsc_code", data?.ifsc_code ? data?.ifsc_code : "");
    }
  };

  const getEventData = async () => {
    const response: any = await getAuctionEventByUuid(bidderData?.event_uuid);
    bidForm.setField("bid_amount", response?.property_dump?.reserve_price);
    bidForm.setField("emd_amount", response?.property_dump?.emd_amount);
  };

  const handleIFSCCode = async (val: string) => {
    bidForm.setField("ifsc_code", val);
    if (val.length === 11 && ifscRegEx.test(val)) {
      axios
        .get(`https://ifsc.razorpay.com/${val}`)
        .then((response: any) => {
          if (response.status === 200) {
            const bank = response?.data?.BANK;
            if (bank) {
              bidForm.setField("bank_name", bank);
              bidForm.removeError("ifsc_code");
            } else {
              bidForm.setField("bank_name", "");
              bidForm.pushError({ ifsc_code: ["Enter Valid IFSC Code"] });
            }
          } else {
            bidForm.setField("bank_name", "");
            bidForm.pushError({ ifsc_code: [response?.data] });
          }
        })
        .catch((error: any) => {
          console.error("Error:", error?.response);
          bidForm.setField("bank_name", "");
          bidForm.pushError({ ifsc_code: [error?.response?.data] });
        });
    } else if (val.length > 11) {
      bidForm.setField("bank_name", "");
      bidForm.pushError({ ifsc_code: ["IFSC Code cannot exceed 11 digits"] });
    } else if (val.length < 11) {
      bidForm.setField("bank_name", "");
    } else {
      bidForm.setField("bank_name", "");
      bidForm.pushError({ ifsc_code: ["Enter Valid IFSC Code"] });
    }
  };

  const handleSubmit = async () => {
    let payload = bidderData || {};
    if (bidForm.validate()) {
      bidForm.startProcessing();
      payload.application_form_data = bidForm?.value;
      const res = await updateBidderForEvent(payload);
      if (res) {
        router.push(`/kyc/${id}?step=${nextStep}`);
      }
      bidForm.finishProcessing();
    }
  };

  return (
    <div className="mx-auto min-h-screen max-w-5xl border py-6 px-12 rounded-md">
      <div className="sm: grid sm:grid-cols-2 gap-4">
        <div className="col-span-2 flex flex-col justify-center items-center">
          <h2 className="font-bold tracking-wide text-2xl">
            Bid Application Form
          </h2>
          <p className="tracking-tighter pt-1 text-gray-400">
            Read the form carefully before proceeding
          </p>
        </div>
        <div className="col-span-2 border-b font-semibold">
          Property:{" "}
          <span className="text-sm font-normal">
            {bidderData?.meta?.event_name}
          </span>
        </div>
        <div className="col-span-2"></div>
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Email",
            }}
            name={"email"}
            onChange={(val) => {}}
            type={"text"}
            value={bidForm.value.email}
            disabled={true}
            htmlFor={"email"}
          />
        </div>
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Mobile Number",
            }}
            name={"mobile"}
            onChange={(val) => {}}
            type={"text"}
            value={bidForm.value.mobile}
            disabled={true}
            htmlFor={"mobile"}
          />
        </div>
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Name",
            }}
            name={"name"}
            onChange={(val) => {}}
            type={"text"}
            value={bidForm.value.name}
            disabled={true}
            htmlFor={"name"}
          />
        </div>
        {onboarding.authorized_person_name && (
          <div>
            <TextInputBase
              autoComplete="off"
              labelBaseProps={{
                label: "Authorized Person Name",
              }}
              name={"authorized_person_name"}
              onChange={(val) => {}}
              type={"text"}
              value={bidForm.value.authorized_person_name}
              disabled={true}
              htmlFor={"authorized_person_name"}
            />
          </div>
        )}
        {!onboarding.authorized_person_name && (
          <div>
            <TextInputBase
              autoComplete="off"
              labelBaseProps={{
                label: "Father/Spouse Name",
              }}
              name={"father_spouse_name"}
              onChange={(val) => {
                bidForm.setField("father_spouse_name", val);
              }}
              type={"text"}
              error={
                bidForm.errors.get("father_spouse_name") ? (
                  <p className="mt-2 text-sm text-red-500">
                    {bidForm.errors.get("father_spouse_name")[0]}
                  </p>
                ) : null
              }
              value={bidForm.getField("father_spouse_name")}
              disabled={false}
              htmlFor={"father_spouse_name"}
            />
          </div>
        )}
        {/* <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Aadhaar",
            }}
            name={"aadhaar"}
            onChange={(val) => {}}
            type={"text"}
            value={bidForm.value.aadhaar}
            disabled={true}
            htmlFor={"aadhaar"}
          />
        </div> */}
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "PAN",
            }}
            name={"pan"}
            onChange={(val) => {}}
            type={"text"}
            value={bidForm.value.pan}
            disabled={true}
            htmlFor={"pan"}
          />
        </div>
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Full Address",
            }}
            name={"full_address"}
            onChange={(val) => {
              bidForm.setField("full_address", val);
            }}
            type={"text"}
            error={
              bidForm.errors.get("full_address") ? (
                <p className="mt-2 text-sm text-red-500">
                  {bidForm.errors.get("full_address")[0]}
                </p>
              ) : null
            }
            value={bidForm.getField("full_address")}
            disabled={false}
            htmlFor={"full_address"}
          />
        </div>
        <div className="col-span-2 border-b font-semibold">Bidds details</div>
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Bid Amount",
            }}
            name={"bid_amount"}
            onChange={(val) => {
              bidForm.setField("bid_amount", val);
            }}
            type={"text"}
            error={
              bidForm.errors.get("bid_amount") ? (
                <p className="mt-2 text-sm text-red-500">
                  {bidForm.errors.get("bid_amount")[0]}
                </p>
              ) : null
            }
            value={bidForm.getField("bid_amount")}
            disabled={true}
            htmlFor={"bid_amount"}
          />
        </div>
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "EMD Amount",
            }}
            name={"emd_amount"}
            onChange={(val) => {
              bidForm.setField("emd_amount", val);
            }}
            type={"text"}
            error={
              bidForm.errors.get("emd_amount") ? (
                <p className="mt-2 text-sm text-red-500">
                  {bidForm.errors.get("emd_amount")[0]}
                </p>
              ) : null
            }
            value={bidForm.getField("emd_amount")}
            disabled={true}
            htmlFor={"emd_amount"}
          />
        </div>
        <div className="col-span-2 border-b font-semibold">
          Account Details (Refund)
        </div>
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Account Name",
            }}
            name={"acount_name"}
            onChange={(val) => {
              bidForm.setField("account_name", val);
            }}
            type={"text"}
            error={
              bidForm.errors.get("account_name") ? (
                <p className="mt-2 text-sm text-red-500">
                  {bidForm.errors.get("account_name")[0]}
                </p>
              ) : null
            }
            value={bidForm.getField("account_name")}
            disabled={false}
            htmlFor={"account_name"}
          />
        </div>
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Account Number",
            }}
            name={"account_number"}
            onChange={(val) => {
              bidForm.setField("account_number", val);
            }}
            type={"text"}
            error={
              bidForm.errors.get("account_number") ? (
                <p className="mt-2 text-sm text-red-500">
                  {bidForm.errors.get("account_number")[0]}
                </p>
              ) : null
            }
            value={bidForm.getField("account_number")}
            disabled={false}
            htmlFor={"account_number"}
          />
        </div>
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Account Type",
            }}
            name={"account_type"}
            onChange={(val) => {
              bidForm.setField("account_type", val);
            }}
            type={"text"}
            error={
              bidForm.errors.get("account_type") ? (
                <p className="mt-2 text-sm text-red-500">
                  {bidForm.errors.get("account_type")[0]}
                </p>
              ) : null
            }
            value={bidForm.getField("account_type")}
            disabled={false}
            htmlFor={"account_type"}
          />
        </div>
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "IFSC",
            }}
            name={"ifsc_code"}
            onChange={(val: any) => handleIFSCCode(val)}
            type={"text"}
            error={
              bidForm.errors.get("ifsc_code") ? (
                <p className="mt-2 text-sm text-red-500">
                  {bidForm.errors.get("ifsc_code")[0]}
                </p>
              ) : null
            }
            value={bidForm.getField("ifsc_code")}
            disabled={false}
            htmlFor={"ifsc_code"}
          />
        </div>
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Bank Name",
            }}
            name={"bank_name"}
            onChange={(val) => {
              bidForm.setField("bank_name", val);
            }}
            type={"text"}
            error={
              bidForm.errors.get("bank_name") ? (
                <p className="mt-2 text-sm text-red-500">
                  {bidForm.errors.get("bank_name")[0]}
                </p>
              ) : null
            }
            value={bidForm.getField("bank_name")}
            disabled={false}
            htmlFor={"bank_name"}
          />
        </div>
        <div className="flex justify-end text-center pt-2 col-span-2">
          <ButtonBase
            variant="primary"
            type="button"
            label={"Save & Submit"}
            onClick={() => handleSubmit()}
            buttonBaseClasses={{
              font: "text-base font-medium",
              backgroundColor: "bg-green-600 hover:bg-green-700",
              textColor: "text-white",
              border: "any",
              padding: "px-4 py-2",
            }}
            busy={bidForm.busy}
            busyText={<Loader height="h-6" width="w-6" />}
          />
        </div>
      </div>
    </div>
  );
};

export default BidForm;
